export default __webpack_public_path__ + "15c5253f610f1d478c77bb3533dd2014.svg";